import { Link } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { AuthenticationLayout } from '@/components/layout/AuthenticationLayout.tsx'

export function ExpiredLinkPage() {
  const { t } = useTranslation()

  return (
    <AuthenticationLayout
      icon={<Link className='w-6 h-6 text-dark-600' />}
      title={t('auth.theLinkHasExpired')}
      description={t('auth.theLinkHasExpiredDescription')}
    />
  )
}
